<template>
    <div id="breadcrumbs">
        <router-link :to="to">
            <font-awesome-icon icon="fa-solid fa-circle-arrow-left" class="icon-arrow"/>
        </router-link>
        <ul id="breadcrumbs-items">
            <li v-for="(breadcrumbs, index) in breadcrumbItem" :key="index">{{ breadcrumbs}}</li>
        </ul>
        <div style="clear:both;"></div>
    </div>
</template>
<script>
export default {
    name: "BreadcrumbsMobile",
    props: {
        breadcrumbItem: Array,
        to: String
    }
}
</script>
<style scoped>
#breadcrumbs{
    margin-bottom:10px;
}
#breadcrumbs-items{
    margin:0;
    padding:0;
    float:right;
}
#breadcrumbs-items li{
    display: inline-block;
    margin-right:10px;
    padding-top:10px;
    color:#A61F69;
    text-transform: capitalize;
    font-size:1.3em;
}
#breadcrumbs-items li:first-child:before{
    content:""
}
#breadcrumbs-items li:before{
    content: " / "
}
</style>
